module.exports = __webpack_public_path__ + "media/images/logos/app-logo-white-b7751a2363281f8995c9405c974854b4.svg";